import axios from "axios";
import Session from './../session'

var instance = axios.create({
    baseURL: window.location.origin,
});

export default {
    namespaced: true,
    state: {
        isLoading: true,
        categories: [],
        bayadBalance:[],
        billers: [],
        filter: {
            category: "0",
            keyword: ""
        },
        filteredBiller: []
    },
    getters: {},
    mutations: {
        SET_IsLoading(state, value) {
            state.isLoading = value;
        },
        SET_Categories(state, value) {
            state.categories = value;
        },
        SET_Billers(state, value) {
            state.billers = value;
        },
        FILTER_Biller(state) {
            state.filteredBiller = Object.assign([], state.billers);

            if (state.filter.category != '0') {
                state.filteredBiller = state.filteredBiller.filter(m => m.category == state.filter.category);
            }

            if (state.filter.keyword != '') {
                state.filteredBiller = state.filteredBiller.filter(
                    m => m.name.toLowerCase().includes(state.filter.keyword.toLowerCase()) ||
                        m.code.toLowerCase().includes(state.filter.keyword.toLowerCase()) ||
                        m.description?.toLowerCase().includes(state.filter.keyword.toLowerCase()));
            }
        },
        SET_BayadBalance(state, payload) {
            state.bayadBalance = payload;
        },
    },
    actions: {
        GetBayadBalance({ commit }) {
            commit('SET_IsLoading', true);

            return new Promise((resolve, reject) => {
                instance
                    .get("api/tpa/balance", {
                        headers: {
                            Authorization: "Bearer " + Session.token(),
                        }
                    })
                    .then(async function (response) {
                        commit('SET_BayadBalance', response.data.balance);
                        commit('SET_IsLoading', false);
                        resolve(true);
                    })
                    .catch(function (error) {
                        commit('SET_IsLoading', false);
                        reject(error.response);
                    });
            });
        },
        GetCategories({ commit }) {
            commit('SET_Categories', []);

            return new Promise((resolve, reject) => {
                instance
                    .get("api/biller/v2/categories", {
                        headers: {
                            Authorization: "Bearer " + Session.token()
                        }
                    })
                    .then(async function (response) {
                        commit('SET_Categories', response.data.categories);
                        resolve(true);
                    })
                    .catch(function (error) {
                        reject(error.response);
                    });
            });
        },
        GetBillers({ commit }) {
            commit('SET_Billers', []);
            commit('SET_IsLoading', true);

            return new Promise((resolve, reject) => {
                instance
                    .get("api/billers?category=", {
                        headers: {
                            Authorization: "Bearer " + Session.token()
                        }
                    })
                    .then(async function (response) {
                        commit('SET_Billers', response.data);
                        commit('FILTER_Biller');
                        commit('SET_IsLoading', false);
                        resolve(true);
                    })
                    .catch(function (error) {
                        reject(error.response);
                    });
            });
        },
        UpdateBillerStatus({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .put(`api/biller/${payload.code}/status?status=${payload.status}`, {
                        headers: {
                            Authorization: "Bearer " + Session.token()
                        }
                    })
                    .then(async function (response) {
                        resolve(true);
                    })
                    .catch(function (error) {
                        reject(error.response);
                    });
            });
        },
        UpdateBillerSfSharing({ commit }, payload) {
            const url = `api/biller/${payload.code}/sfsharing?sfSharing=${payload.sfSharing}`;
            console.log('=== VUEX ACTION UpdateBillerSfSharing ===');
            console.log('Full URL:', url);
            console.log('Payload:', payload);
            console.log('Token exists:', !!Session.token());

            return new Promise((resolve, reject) => {
                instance
                    .put(url, {}, {
                        headers: {
                            Authorization: "Bearer " + Session.token()
                        }
                    })
                    .then(async function (response) {
                        console.log('API Success Response:', response);
                        console.log('Response data:', response.data);
                        console.log('Response status:', response.status);
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error('=== API ERROR ===');
                        console.error('Error:', error);
                        console.error('Error response:', error.response);
                        console.error('Error status:', error.response?.status);
                        console.error('Error data:', error.response?.data);
                        reject(error);
                    });
            });
        },
    },
}